<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle class="d-flex align-center pb-2">
      <v-icon small color="primary" class="mr-2">mdi-food-variant</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("menu_type") }}</span>
    </v-card-subtitle>
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <div v-else-if="menuTypes.length === 0" class="text-center py-4 grey--text">
        <v-icon color="grey">mdi-alert-circle-outline</v-icon>
        <div>{{ $t("no_menu_types_available") }}</div>
      </div>
      <div v-else class="checkbox-grid-4">
        <v-checkbox
          v-for="check in menuTypes"
          :key="check.id"
          v-model="editedItem.type"
          :label="$t(check.name)"
          :value="check.id"
          hide-details
          dense
        ></v-checkbox>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import menuService from '@/services/menu';

export default {
  name: 'FoodMenuType',
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menuTypes: [],
      loading: false,
    };
  },
  created() {
    this.loadMenuTypes();
  },
  methods: {
    loadMenuTypes() {
      this.loading = true;
      menuService
        .getMenuTypes()
        .then((res) => {
          if (res.data) {
            this.menuTypes = res.data;
          }
        })
        .catch((error) => {
          console.error('Error loading menu types:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.checkbox-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

@media (max-width: 960px) {
  .checkbox-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .checkbox-grid-4 {
    grid-template-columns: 1fr;
  }
}
</style>
